// 360 Product viewer plugin docs - https://github.com/Scaleflex/js-cloudimage-360-view

class PC360ProductViewer {
    constructor(element, index) {
        this.index = index;
        this.element = element;
        this.pluginInit = false;
        this.viewerAdded = false;
        this.intervalId;

        this.init();
        this.listen();
    }

    init() {
    }

    listen() {
        this.element.addEventListener('mouseenter', () => {
            this.init360Viewer();
        });

        this.element.addEventListener('click', () => {
            this.openModal();
        });
    }

    openModal() {
        const viewer = this.element.querySelector('.pc-360-product-viewer__viewer');
        const modalTrigger = this.element.querySelector('.cloudimage-360-fullscreen-icon');

        if (modalTrigger) {
            modalTrigger.click();
        }
    }

    init360Viewer() {
        // initiliaze the plugin
        if (false === this.pluginInit) {
            jQuery(this.element).trigger('pc_360_product_viewer:init_plugin', this.index);
        }
        
        // add the viewer
        if (false === this.viewerAdded) {
            window.CI360.add(this.element);

            this.element.classList.add('is-active');
            this.viewerAdded = true;

            jQuery(this.element).trigger('pc_360_product_viewer:viewer_added', this.index);
        }
    }
}

class PC360ProductViewerCollection {
    constructor(selector) {
        this.selector = selector;
        this.collection = [];
        this.pluginInit = false;

        this.init();
        this.listen();
    }

    init() {
        let items = document.querySelectorAll(this.selector);

        if (items.length) {
            items.forEach((item, index) => {
                this.collection.push(new PC360ProductViewer(item, index));
            });
        }
    }

    listen() {
        jQuery(document).on('pc_360_product_viewer:init_plugin', (event, index) => {
            this.initPlugin();
        });
    }

    initPlugin() {
        window.CI360.init();
        this.pluginInit = true;

        this.collection.forEach((item, i) => {
            item.pluginInit = true;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.synapse = window.synapse || {};
    
    window.synapse.PC360ProductViewerCollection = new PC360ProductViewerCollection('.pc-360-product-viewer');
});